import { NextPage } from 'next';
import React from 'react';

import PageHandler from '@jpp/shared/PageHandler';
import FAQ from '@jpp/templates/FAQ';
import { IPageStoreState } from 'common/redux/page/reducer';
import { EPageType } from 'common/typings/enums';
import { TReduxError, TTemplateInitialProps } from 'common/typings/types';
import axios from 'common/utils/axios/internal';
import { shouldPageError } from 'common/utils/shared/page';
import { getQueryParamFirstValue } from 'common/utils/shared/route';
import { IPageAPIState } from 'common/utils/transformers/page.transformer';

interface IFaqsPageProps {
  error?: TReduxError;
  slug?: string;
  page: IPageStoreState;
}

type TFaqsPage = IFaqsPageProps;

const FaqsPage: NextPage<TFaqsPage> = ({ error, page, slug }) => {
  return (
    <PageHandler
      page={{
        ...page,
        slug,
      }}
      error={error}
      pageType={EPageType.Faq}
      template={FAQ}
    />
  );
};

FaqsPage.getInitialProps = async ({
  query,
  store,
  res,
}: TTemplateInitialProps<{ slug: string }>): Promise<TFaqsPage> => {
  const dispatch = store.dispatch;
  const slug = getQueryParamFirstValue(query.slug);
  const { data: page } = await axios.get<IPageAPIState>(`/faq/${slug}`);
  await shouldPageError(page, res, dispatch);

  return {
    slug,
    page,
  };
};

export default FaqsPage;
